import { render } from "./single-flash-poster.vue?vue&type=template&id=571cffa4&scoped=true"
import script from "./single-flash-poster.vue?vue&type=script&lang=js"
export * from "./single-flash-poster.vue?vue&type=script&lang=js"

import "./single-flash-poster.vue?vue&type=style&index=0&id=571cffa4&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571cffa4"]])

export default __exports__